import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import Input from '@material-ui/core/Input';
import './EmployeeDataForm.scss';
import FormControl from "@material-ui/core/FormControl";

const EmployeeDataForm = (props) => {
  const { classes, step, onComplete, currentValue } = props

  const [department, setDepartment] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [interval, setInterval] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (department.trim().length > 0 && firstname.trim().length > 0 && lastname.trim().length > 0 && interval.trim().length > 0) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  }, [department, firstname, lastname, interval]);

  const handleSubmit = (e) => {
    e.preventDefault();

    setSubmitted(false);
    setSubmitting(true);
    onComplete({department, firstname, lastname, interval}, `\nBereich: ${department}\nName: ${firstname} ${lastname}\nZeitraum: ${interval}`)
    setSubmitting(false);
    setSubmitted(true);
  }

  return (
    <div className={classNames("d-flex flex-column flex-lg-row justify-content-between", classes)}>
      <form className="form-wrapper" onSubmit={(e) => handleSubmit(e)}>
        <div className="row py-4 py-md-5 px-1">
          <h2 className="headline p w-35 w-md-12 d-flex align-items-center">{step.labelDepartment}</h2>
          <div className="w-45 w-md-21 pt-3 pt-md-0">
            <FormControl className="input-wrapper">
              <Input
                placeholder={step.placeholderDepartment}
                type="text"
                className="input-text mb-3"
                fullWidth
                disableUnderline
                value={department}
                onChange={e => setDepartment(e.target.value)}
              />
            </FormControl>
          </div>
        </div>

        <div className="row py-4 py-md-5 px-1">
          <h2 className="headline p w-35 w-md-12">{step.labelName}</h2>
          <div className="w-45 w-md-21 pt-3 pt-md-0">
            <div className="row">
              <div className="col-12 col-sm-6 pr-0 pl-0">
                <div className="pr-sm-1 input-wrapper">
                  <Input
                    placeholder={step.placeholderFirstname}
                    inputProps={{
                      'aria-label': 'firstname',
                      pattern: "^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]+(([',. -][a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ])?[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]*)*$"
                    }}
                    id="firstname"
                    name="firstname"
                    className="input-text mb-3"
                    required
                    autoComplete="given-name"
                    fullWidth
                    disableUnderline
                    value={firstname}
                    onChange={e => setFirstname(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-6 pr-0 pl-0">
                <div className="pl-sm-1 input-wrapper">
                  <Input
                    placeholder={step.placeholderLastname}
                    inputProps={{
                      'aria-label': 'lastname',
                      pattern: "^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]+(([',. -][a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ])?[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]*)*$"
                    }}
                    id="lastname"
                    name="lastname"
                    className="input-text mb-3"
                    required
                    autoComplete="family-name"
                    fullWidth
                    disableUnderline
                    value={lastname}
                    onChange={e => setLastname(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row py-4 py-md-5 px-1">
          <h2 className="headline p w-35 w-md-12 d-flex align-items-center">{step.labelInterval}</h2>
          <div className="w-45 w-md-21 pt-3 pt-md-0">
            <FormControl className="input-wrapper">
              <Input
                placeholder={step.placeholderInterval}
                type="text"
                className="input-text mb-3"
                fullWidth
                required
                disableUnderline
                value={interval}
                onChange={e => setInterval(e.target.value)}
              />
            </FormControl>
          </div>
        </div>

        <div className="survey-step-content-buttons" data-num-buttons={step.buttons.length}>
          <button
            type="button"
            onClick={handleSubmit}
            className={`survey-step-content-buttons-rating ${submitted ? 'survey-step-content-buttons-rating--active' : ''}`}
            disabled={disableSubmit || submitting}
          >
            {
              submitting ?
                (<svg width="14" height="14" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                      <stop stopColor="currentColor" stopOpacity="0" offset="0%"/>
                      <stop stopColor="currentColor" stopOpacity=".631" offset="63.146%"/>
                      <stop stopColor="currentColor" offset="100%"/>
                    </linearGradient>
                  </defs>
                  <g fill="none" fillRule="evenodd">
                    <g transform="translate(1 1)">
                      <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" strokeWidth="2">
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 18 18"
                          to="360 18 18"
                          dur="0.9s"
                          repeatCount="indefinite" />
                      </path>
                      <circle fill="currentColor" cx="36" cy="18" r="1">
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 18 18"
                          to="360 18 18"
                          dur="0.9s"
                          repeatCount="indefinite" />
                      </circle>
                    </g>
                  </g>
                </svg>)
                :
                step.labelSubmitData
            }
          </button>
        </div>
      </form>
    </div>
  )
}

export default EmployeeDataForm
